module.exports = __webpack_public_path__ + "static/media/daily class attendance.25497716.svg";